import { cva, type VariantProps } from 'class-variance-authority';

const variants = cva('block animate-pulse rounded-sm bg-neutral-300', {
  variants: {
    size: {
      sm: 'h-4',
      md: 'h-6',
      lg: 'h-12',
    },
  },
  defaultVariants: {
    size: 'sm',
  },
});

export interface LoadingTextProps extends VariantProps<typeof variants> {}

export default function LoadingText({ size }: LoadingTextProps) {
  return (
    <span className={variants({ size })} data-testid="loading-text" aria-busy />
  );
}
